import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';
import bind from 'bind-decorator';

export class SheetTabNameValidator
{

    @bind
    public static isInvalidSheetName(name:string):boolean
    {
        return !name || name.length === 0;
    }

    @bind
    public static sheetWithNameExists(workbookId:WorkbookId, sheetId:string, name:string):boolean
    {
        const existingSheet = commonControllers.spreadsheets.workbook.findSheetByName(workbookId, name);
        if( existingSheet && existingSheet.id !== sheetId )
            return true;
        return false;
    }

    @bind
    public static isValidSheetName(workbookId:WorkbookId, sheetId:string, name:string):boolean
    {
        return !this.isInvalidSheetName(name) && !this.sheetWithNameExists(workbookId, sheetId, name);
    }
}
